import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/lib/constants/routes';
import { verifySharedProfileOtp } from '../api/shared-profile.api';
import { setShareAccessToken } from '../api/share-access-storage';

/**
 * Verify the code and open the view session (MYN-58). On success, persists
 * the view-session token for this tab and routes to the read-only profile.
 */
export function useVerifySharedProfileOtp(token: string) {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (code: string) => verifySharedProfileOtp(token, code),
    onSuccess: ({ accessToken }) => {
      setShareAccessToken(token, accessToken);
      navigate(ROUTES.SHARED_PROFILE_VIEW.replace(':token', token));
    },
  });
}
